/* eslint-disable no-console */

import ReactDOM from 'react-dom';

/**
 *
 * @warn dangerous!
 *
 * calls flushSync with `fn` and suppresses the lifecycle warning. this
 * allows you to call flushSync from lifecycle methods, which works but isnt
 * great
 *
 */
export const suppressedFlushSync = (fn: () => void) => {
  const nativeError = console.error;
  console.error = () => undefined;
  ReactDOM.flushSync(fn);
  console.error = nativeError;
};
